<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          :max-width="cartDetail.width || 50"
          contain
          :src="require(`@/assets/conectiontab/${cartDetail.src}`)"
          :class="cartDetail.class ||'mx-3 mt-4'"
        />
        <h2
          style="line-height:85px;"
          class="mr-3"
        >
          {{ cartDetail.pageHeading }}
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          :v-track="`close-${cartType}-integration-drawer`"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <h2> {{ editingStoreId ? 'Edit' : 'Add' }} Integration</h2>
      <div class="divider-width">
        <p class="my-4">
          In order to connect your {{ cartDetail.pageHeading }} account with Maropost, please enter a name and your {{ cartDetail.pageHeading }} merchant ID, and sync it with a Maropost List.
        </p>

        <div class="mr-5 mb-5 pb-1">
          <div class="pt-3 pb-1 px-3 bg-grey d-flex body-2">
            <v-icon
              class="mr-2 position-icon"
              size="18"
            >
              mdi-information-outline
            </v-icon>
            <p>
              Only customer data with email addresses in {{ cartDetail.pageHeading }} can be synced with Maropost.
              <a
                v-track="`${cartType}-help-center-link`"
                :href="cartDetail.link"
                target="_blank"
              >
                Learn More
              </a>
            </p>
          </div>
        </div>
        <v-divider
          class="pb-3 mr-5"
        />
      </div>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="mr-5 mt-3"
      >
        <div class="d-flex justify-space-between mt-3">
          <v-text-field
            v-model="payload.name"
            label="Name *"
            persistent-hint
            outlined
            class="mt-2"
            :rules="[v => !!v || 'Name is required']"
            required
          />
          <span class="ml-1">
            <v-tooltip
              top
              color="rgba(0, 0, 0, 0.9)"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :v-track="`${cartType}-marketing-name-info-icon`"
                  icon
                  small
                  class="mt-5 px-0 pb-0"
                  v-on="on"
                >
                  <v-icon>
                    mdi-information-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Enter your {{ cartDetail.pageHeading }} Name</span>
            </v-tooltip>
          </span>
        </div>
        <div class="d-flex justify-space-between mt-0">
          <v-text-field
            v-model="payload.merchant_id"
            label="Merchant ID *"
            persistent-hint
            outlined
            class="mt-2"
            :rules="[v => !!v || 'Merchant ID is required']"
            required
          />
          <span class="ml-1">
            <v-tooltip
              top
              color="rgba(0, 0, 0, 0.9)"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :v-track="`${cartType}-api-info-icon`"
                  icon
                  small
                  class="mt-5 px-0 pb-0"
                  v-on="on"
                >
                  <v-icon>
                    mdi-information-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Enter your {{ cartDetail.pageHeading }} Merchant ID</span>
            </v-tooltip>
          </span>
        </div>
        <div
          v-if="cartType == '1shoppingcart'"
          class="d-flex justify-space-between mt-0"
        >
          <v-text-field
            v-model="payload.merchant_key"
            label="Merchant Key *"
            persistent-hint
            outlined
            class="mt-2"
            :rules="[v => !!v || 'Merchant Key is required']"
            required
          />
          <span class="ml-1">
            <v-tooltip
              top
              color="rgba(0, 0, 0, 0.9)"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :v-track="`${cartType}-key-info-icon`"
                  icon
                  small
                  class="mt-5 px-0 pb-0"
                  v-on="on"
                >
                  <v-icon>
                    mdi-information-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Enter your {{ cartDetail.pageHeading }} Merchant Key</span>
            </v-tooltip>
          </span>
        </div>

        <v-btn
          v-if="firstConnection"
          :v-track="`${cartType}-connect-store`"
          :class="{
            'mt-5 mb-5': true,
            'theme--dark': isDarkTheme
          }"
          :loading="isConnecting"
          :disabled="isButtonDisabled"
          @click="makeCartConnection()"
        >
          Connect
        </v-btn>
        <v-btn
          v-if="editStore"
          :v-track="`${cartType}-update-store`"
          :class="{
            'mt-5 mb-5': true,
            'theme--dark': isDarkTheme
          }"
          :loading="isConnecting"
          :disabled="isButtonDisabled"
          @click="updateStore()"
        >
          Save
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
  import { $integrations, $contacts, $lists } from '@/services'
  import CreateListOption from '@/components/shared/CreateListOption'
  import constants from '@/constants'
  import IntegrationsCustomFieldMapping from "@/components/shared/IntegrationsCustomFieldMapping.vue"
  import { getSplitKey } from '@/splitClient';

  export default {
    name: 'CartsIntegrationDrawer',
    components: {
      CreateList: () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ?  import('@/views/lists/lists/UIDCreateList.vue') : import('@/views/lists/lists/CreateList.vue') ,
      CreateListOption,
      IntegrationsCustomFieldMapping
    },
    data () {
      return {
        payload: {},
        valid: true,
        maro_list: [],
        enableScroll: true,
        page: 0,
        count: null,
        editingStoreId: null,
        isConnecting: false,
        contactDialog: false,
        storeData: {},
        isMounted: false,
        customLists: [],
        selectorClass: '',
        cfields: '',
        search: null,
        isSearching: false,
        dataLoader: false,
        listNames: [],
        constants: constants,
        mappedFields: [
          { cart: '', maro: '' }
        ],
        marketingFields: [],
        cartFields: [],
      }
    },
    computed: {
      isButtonDisabled () {
        return !this.payload.merchant_id || !this.payload.name ||
          (this.cartType == '1shoppingcart' && !this.payload.merchant_key)
      },
      isDarkTheme () {
        return this.payload.merchant_id && this.payload.name &&
          (!['1shoppingcart'].includes(this.cartType) ||
            (this.cartType == '1shoppingcart' && this.payload.merchant_key)
            )
      },
      firstConnection () {
        return this.$store.getters['ui/drawer'].right.firstConnection
      },
      editStore () {
        return this.$store.getters['ui/drawer'].right.editStore
      },
      cartType () {
        return this.$route.params.cartType || this.$store.getters['ui/drawer'].right.cartType
      },
      cartDetail () {
        let cartObj = {}
        switch (this.cartType) {
          case '1shoppingcart':
            cartObj = {
              pageHeading: '1ShoppingCart',
              src: '1sshopping-drawer.png',
              link: 'https://galaxy.maropost.com/s/article/Integration-with-1ShoppingCart',
              payloadCardType: 'one_shopping_cart',
              width: 35,
              class: 'mx-3 mt-0',
            }
            break
          case 'ultracart':
            cartObj = {
              pageHeading: 'UltraCart',
              src: 'ultracart.png',
              link: 'https://galaxy.maropost.com/s/article/Integration-with-UltraCart',
              payloadCardType: 'ultra_cart',
              width: 33,
              class: 'mx-3 mt-0',
            }
            break
          case 'nanacastcart':
            cartObj = {
              pageHeading: 'Nanacast',
              src: 'logo.png',
              link: 'https://galaxy.maropost.com/s/article/Integration-with-Nanacast',
              payloadCardType: 'nanacast_cart',
              class: 'ml-3 mr-2 mt-1',
              width: 40,
            }
            break
          case 'shift4shop':
            cartObj = {
              pageHeading: 'Shift4Shop',
              src: '3dcart_logo.png',
              link: 'https://galaxy.maropost.com/s/article/Integration-with-Shift4Shop',
              payloadCardType: '3d_cart',
              class: 'mx-3 mt-0',
            }
            break
        }
        return cartObj
      },
    },
    mounted () {
      if (this.$store.getters['ui/drawer'].right.storeData &&
        this.$store.getters['ui/drawer'].right.storeData.id
      ) {
        const data = this.$store.getters['ui/drawer'].right.storeData
        this.payload = {
          merchant_id: data.merchant_id,
          merchant_key: data.merchant_key,
          name: data.name,
        }
        this.editingStoreId = data.id
        this.payload = { ...this.payload }
      }
      this.isMounted = true
    },
    methods: {
      clearItems () {
        this.payload.list_id = null
      },
      getCustomFields (searchingVal) {
        this.dataLoader = '#03b6fc'
        ++this.page
        const params = {
          page: this.page,
          per_page: 10,
        }
        if(searchingVal){
          params.name = searchingVal
        }
        $contacts.getCustomFields({ params }).then(response => {
          if (response.data) {
            let data = response.data.data
            data.forEach((element) => {
                const index = this.customLists.findIndex(
                  (item) => item.id === element.id
                )
                if (index < 0) {
                  this.customLists.push(element)
                }
              })
          }
        })
        .finally(() =>{
          this.dataLoader = false;
        })
      },
      addListener () {
        this.selectorClass = '.v-autocomplete__content'
        var el = document.querySelector(this.selectorClass)
        /** add scroll event **/
        if (el) {
          el.addEventListener('scroll', this.onScroll)
        }
      },
      onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
        if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
          this.getCustomFields()
        }
      },
      validate () {
        return this.$refs.form.validate()
      },
      async makeCartConnection () {
        this.valid = this.validate()
        this.payload.cart_type = this.cartDetail.payloadCardType
        if (this.valid) {
          $integrations.createCartConnection(this.payload)
            .then(res => {
              this.navigateInfoPage(res.data)
              this.$store.commit('ui/snackbar', {
                message: 'New Integration was successfully added.',
                type: 'success',
              })
            })
            .finally(() => {
              this.isConnecting = false
            })
        }
      },
      navigateInfoPage (storeData) {
        this.$store.commit('ui/drawer.right', {
          component: 'CartsDetailDrawer',
          show: true,
          width: '700px',
          storeData: storeData,
          cartType: this.cartType
        })
      },
      updateStore () {
        this.isConnecting = true
        if (this.payload.name !== undefined) {
          let payload = {
            cart: this.payload
          };
          payload['cfields'] = this.cfields
          $integrations.updateCart(this.editingStoreId, payload)
            .then(() => {
              this.$store.commit('ui/snackbar', {
                message: 'Integration Successfully Updated!',
                type: 'success',
              })
              setTimeout(() => {
                this.$store.commit('ui/drawer.right', {
                  component: 'CartsIntegrationDrawer',
                  show: false,
                  width: '700px',
                })
              }, 1000)
              this.$router.push({
                name: 'Cart_index',
                params: {
                  cartType: this.cartType,
                },
                query: { edit: new Date().getTime() },
              })
            })
            .finally(() => {
              this.isConnecting = false
            })
        }
      },
    },
    watch: {
      search (val) {
        if (val) {
          this.isSearching = true
          this.getCustomFields(val);
        } else {
          this.isSearching = false
        }
      },
    },
  }
</script>

<style scoped>
.bg-grey{
  background-color: #F4F4F4;
}
.mt-55{
  margin-top: 55px !important;
}
.position-icon{
  position: relative;
  bottom: 17px;
}
.divider-width{
  width:95%;
}
</style>
